enum StatusType {
  ACTIVE = 'A',
  INACTIVE = 'I',
}

export default StatusType;
